import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import Antd from 'ant-design-vue'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import 'ant-design-vue/dist/antd.css'
import './css/style.less'
import i18n from '../../../src/language/locale.js'
import util from '@/utils/util'
Vue.use(util)
Vue.use(Antd)
Vue.use(Viewer)
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
